import { Trans } from "@lingui/react/macro";
import { i18n } from "@lingui/core";
import {
  Button,
  Input,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@heroui/react";
import { useState, useEffect, ChangeEvent } from "react";
import { Language } from "@/server-types";

export type LocalizedArray = Array<{
  language: Language;
  value: string;
}>;

interface LocalizationFormProps {
  localized: LocalizedArray;
  opened: boolean;
  save: (localized: LocalizedArray) => void;
  cancel: () => void;
  inputLabel: string;
}

export const LocalizationForm = ({
  localized,
  opened,
  save,
  cancel,
  inputLabel,
}: LocalizationFormProps) => {
  const [tempLocalized, setTempLocalized] = useState<LocalizedArray>(localized);

  useEffect(() => {
    setTempLocalized(localized);
  }, [localized]);

  const firstLanguage = i18n.locale as Language;
  const sortedLanguages = [...tempLocalized].sort((a, b) =>
    a.language === firstLanguage ? -1 : b.language === firstLanguage ? 1 : 0,
  );

  return (
    <Modal isOpen={opened} onClose={cancel} size="lg" scrollBehavior="inside">
      <ModalContent>
        {() => (
          <>
            <ModalHeader>
              <Trans>Nastavitve prevodov</Trans>
            </ModalHeader>
            <ModalBody>
              <div className="mt-4 flex flex-col gap-4 overflow-y-auto">
                {sortedLanguages.map((languageRow, index) => (
                  <Input
                    key={index}
                    variant="bordered"
                    label={
                      <div className="flex items-center gap-2">
                        <span className="text-foreground">{inputLabel}</span>
                        <span className="text-sm text-default-500">
                          ({languageRow.language.toUpperCase()})
                        </span>
                      </div>
                    }
                    value={languageRow.value}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => {
                      const value = e.target.value;
                      const newObject = tempLocalized.map((loc) =>
                        loc.language === languageRow.language
                          ? { ...loc, value: value }
                          : loc,
                      );
                      setTempLocalized(newObject);
                    }}
                  />
                ))}
              </div>
            </ModalBody>
            <ModalFooter>
              <div className="flex w-full items-center justify-center gap-4">
                <Button variant="light" onPress={cancel}>
                  <Trans>Prekliči</Trans>
                </Button>
                <Button
                  onPress={() => {
                    save(tempLocalized);
                  }}
                >
                  <Trans>Shrani</Trans>
                </Button>
              </div>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
